let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("58lSo")).then(() => parcelRequire('c5DUK'));